<div class="btn-group">
  <input type="file" (change)="select(input)" #input hidden />
  <button class="btn btn-{{ props.btnClass }}" (click)="input.click()">
    <i class="{{ props.iconClass }}"></i> {{ props.text }}
  </button>
  <div class="btn-group" ngbDropdown>
    <button class="btn btn-{{ props.btnClass }} dropdown-toggle-split" ngbDropdownToggle></button>
    <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
      <input type="file" (change)="selectDropdown(inputDropdown)" #inputDropdown hidden />
      @for (dropdown of props.dropdown.items; track dropdown.text) {
        <button class="btn" (click)="clickDropdown(dropdown, $event)" ngbDropdownItem>
          <i class="{{ dropdown.iconClass }}"></i> {{ dropdown.text }}
        </button>
      }
    </div>
  </div>
</div>
